/**
 * What an operator typed, without the spaces and dashes people group a long
 * code with, in capitals: how a typed ICCID is read, and a typed order code
 * that is not a valid one. One rule, so the two cannot read a paste apart.
 */
export function compactTyped(raw) {
    return raw.replace(/[\s-]/g, "").toUpperCase();
}
//# sourceMappingURL=typed.js.map